import { IAttributeHotel } from './index';

const dataAttributesHotel: IAttributeHotel[] = [
    {
        id: 9,
        key: 'children_animators',
        keyMerged: 'children_animators',
        name: 'Детская анимация',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детская анимация',
        nameEvent: '',
    },
    {
        id: 10,
        key: 'children_pool',
        keyMerged: 'kidsPool',
        name: 'Детский бассейн',
        typeFilter: 'childFilter',
        nameLayer: 'kidsPool',
        nameEvent: '',
    },
    {
        id: 11,
        key: 'children_childmenu',
        keyMerged: 'children_childmenu',
        name: 'Детское меню',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детское меню',
        nameEvent: '',
    },
    {
        id: 12,
        key: 'children_playroom',
        keyMerged: 'children_playroom',
        name: 'Игровая комната',
        typeFilter: 'childFilter',
        nameLayer: '',
        nameEvent: '',
    },
    {
        id: 16,
        key: 'children_clubs',
        keyMerged: 'children_clubs',
        name: 'Детские клубы',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детские мини-клуб',
        nameEvent: '',
    },
    {
        id: 17,
        key: 'children_childBed',
        keyMerged: 'children_childBed',
        name: 'Детские кроватки',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детские кроватки',
        nameEvent: '',
    },
    {
        id: 18,
        key: 'children_nanny',
        keyMerged: 'children_nanny',
        name: 'Услуги няни / Уход за детьми',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Услуги няни (платно)',
        nameEvent: '',
    },
    {
        id: 20,
        key: 'beachOwner',
        keyMerged: 'beachOwner',
        name: 'Собственный пляж отеля',
        typeFilter: 'BeachFilter',
        nameLayer: '',
        nameEvent: '',
    },
    {
        id: 21,
        key: 'nearTheCenter',
        keyMerged: 'nearTheCenter',
        name: 'Близко к центру',
        typeFilter: 'NearCenterFilter',
        nameLayer: '',
        nameEvent: '',
    },
];

export default dataAttributesHotel;